import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for Number
 * Only used for deserializing numbers when they could potentially come through as strings,
 * as is the case for URLSearchParams
 */
export const numberSerializer = CreateSerializer(undefined, deserializeNumber);
function deserializeNumber(value) {
    return Number(value);
}
